export default "__VITE_ASSET__61b806b3__"